import { API } from '..';

// Lượt eKYC phía admin: báo cáo lượt gọi nhà cung cấp theo tháng và mở lại lượt cho người đã hỏng quá số lần.
// Endpoint user-service ProfileAdminController (/api/v1/admin/Profile), cần quyền User.Manage.
const BASE = '/v1/user-service/admin/profile';

/** Một dòng báo cáo: tháng theo giờ Việt Nam ("yyyy-MM"), loại gọi, kết quả, số lượt. */
export interface EkycUsageRow {
  month: string;
  action: string; // 'verify-document' | 'liveness-check'
  result: string; // 'ok' | 'fail' | 'duplicate' | 'error'
  count: number;
}

export interface ResetEkycAttemptsResponse {
  userId: string;
  failedSinceReset: number;
  maxFailedAttempts: number;
  resetAt: string;
}

export const getEkycUsage = async (months = 6): Promise<EkycUsageRow[]> => {
  const res = await API.get(`${BASE}/ekyc-usage`, { params: { months } });
  const body = res.data;
  if (Array.isArray(body)) return body;
  return Array.isArray(body?.data) ? body.data : [];
};

/** Mở lại lượt eKYC cho một tài khoản. Cần mã Authenticator (interceptor chuyển totpCode sang header). */
export const resetEkycAttempts = async (userId: string, totpCode?: string): Promise<ResetEkycAttemptsResponse> => {
  const res = await API.post(`${BASE}/reset-ekyc-attempts/${userId}`, null, { params: { totpCode } });
  return res.data?.data ?? res.data;
};
